import { put, select } from 'redux-saga/effects'
import { GESTION_OPERATIVA_CALCULATE_REMAINING_SUCCESS } from '../constants'
import { calculateRemainder } from '../../../common/Utilities'

export default function* calculateRemainingSaga() {

  const gestionOperativa = yield select(state => state.gestionOperativa)
  const {sale, maximoDescuento} = gestionOperativa

  let remainder = 0

  if(sale && maximoDescuento){
    remainder = calculateRemainder({
      discountNewVehicle: maximoDescuento.monto ,
      specialDiscount:sale.special_discount,
      discountUsedVehicle: maximoDescuento.porcentaje, 
      takingCars: sale.Taking_cars,
      saleQuantity: sale.sale_quantity
    })
  }  

  yield put({
    type: GESTION_OPERATIVA_CALCULATE_REMAINING_SUCCESS,
    data: { remainder }
  })

}